var paragraph_default = {
  "fontElementMap": "oMueq",
  "elementSpacing": "bTSJG",
  "text": "M8rfQ bTSJG",
  "child": "QxcVi"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
